import { InteractionManager } from '@/SDK/InteractionManager';
import { logout as ssoLogout } from './authProvider';

/**
 * Releases the workspace if currently open
 */
export const releaseWorkspaceIfOpen = async () => {
	const match = window.location.pathname.match(/^\/workspaceDetails\/(\d+)/);
	if (!match) return;
	try {
		await InteractionManager.getInstance().API.workspaceLockRelease({
			WorkspaceID: Number(match[1]),
		});
	} catch {
		// Best-effort — don't block logout if release fails
	}
};

/**
 * Handles the logout process including:
 * - Releasing any open workspace
 * - Logging out from the SSO provider (if applicable)
 * - Clearing local session data
 */
export const authLogout = async (
	setInitialState?: (callback: (state: any) => any) => void,
) => {
	await releaseWorkspaceIfOpen();

	// Try to logout from the configured SSO provider (Okta or MS Entra)
	try {
		await ssoLogout();
	} catch (error) {
		// Ignore errors, user might not be logged in via SSO
		console.log('Not logged in via SSO or logout failed:', error);
	}

	// Clear local session
	localStorage.removeItem('cargomind_current_user');
	localStorage.removeItem('cargomind_session');

	if (setInitialState) {
		setInitialState((s: any) => ({ ...s, currentUser: undefined }));
	}
};
